import React from "react";
import Icon from "@mdi/react";
import { mdiMenu, mdiBellBadgeOutline, mdiChevronLeft } from "@mdi/js";
import { useHistory } from "react-router-dom";

interface Props {
  children: object;
  noHeader?: boolean;
  firstPage?: boolean;
  btnBack?: boolean;
  title?: string;
  handleToggleSidebar: (toggled: boolean) => void;
}
const MainBody: React.FC<Props> = ({
  children,
  handleToggleSidebar = () => { },
  noHeader = true,
  firstPage = true,
  btnBack = false,
  title = "",
}) => {
  let history = useHistory();
  return (
    <main>
      <div className={`${noHeader || firstPage ? "body2" : "body1"}`}>
        {children}
      </div>
    </main>
  );
};

export default MainBody;
